import assignToThis from '../../../helper/assignToThis';

export class ScenarioCapex {
  
  public spvPurchaseDate: string | null = '';
  public spvPurchase: number | null = null;
  public impactStudy: number | null = null;
  public publicInquiry: number | null = null;
  public permitDisplay: number | null = null;
  public technical: number | null = null;
  public businessDeveloper: number | null = null;
  public archaeologicalAssessment: number | null = null;
  public lawyerFees: number | null = null;
  public assetRent: number | null = null;
  public devContractRenFr: number | null = null;
  public devContractExternal: number | null = null;
  public amoContract: number | null = null;
  public others: number | null = null;
  public productible: number | null = null;
  public authorizations: number | null = null;
  public gridConnection: string | null = '';
  public specializedLink: boolean | null = null;
  public gridConnectionCost: number | null = null;
  public regionShare: number | null = null;
  public telecom: number | null = null;
  public environmentalMonitoring: number | null = null;
  public ercMeasures: number | null = null;
  public lot0_CspsCt: number | null = null;
  public lot1_PublicWorks: number | null = null;
  public lot2_Foundations: number | null = null;
  public lot3_ElectricalNetwork: number | null = null;
  public lot4_PdlPtr: number | null = null;
  public lot5_WindTurbines: number | null = null;
  public lot6_Supervision: number | null = null;
  public lot7_Ess: number | null = null;
  public lot8_Modules: number | null = null;
  public lot9_Decommissioning: number | null = null;
  public lot10_Transport: number | null = null;
  public misc: number | null = null;
  public uncertainties: number | null = null;

  public constructor(obj: object = {}) {
    assignToThis(this, obj);
  }

}
